// extracted by mini-css-extract-plugin
export default {"slides":"YalT9","slides__wrapper":"AhF1V","slide":"tYI5W"};